<span class="Pill Pill--{{ value }}" [class.Pill--isFull]="isFull">
	{{ value | lowerCaseNumber }}
</span>

